import { readAppManifestFile } from '../../app-manifest/file.js';

export async function loadDevCenterComponents(projectFolder: string) {
  try {
    const manifest = await readAppManifestFile(projectFolder);
    return manifest.components;
  } catch {
    return [];
  }
}
